import { Component } from '@angular/core';

@Component({
  selector: 'app-know-more',
  templateUrl: './know-more.component.html',
  styleUrl: './know-more.component.scss'
})
export class KnowMoreComponent {

}
